export default __webpack_public_path__ + "static/media/efix_95_131.15884bcd.png";